import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	errorTitle: {
		id: 'reactions.error.title.generic',
		defaultMessage: 'We couldn’t update the reaction',
		description: 'Generic error title for adding or removing a reaction',
	},
	errorMessage: {
		id: 'reactions.error.message.generic',
		description:
			'Generic error displayed when adding or removing a reaction fails for unhandled cases',
		defaultMessage:
			'If the problem persists, contact {atlassianSupportLink} or your space admin so they can troubleshoot the issue.',
	},
	noReactions: {
		id: 'reactions.no.page.reactions',
		defaultMessage: 'Be the first to add a reaction',
		description: 'Placeholder text to encourage the user to react to the page content',
	},
	viewError: {
		id: 'reactions.view.error',
		defaultMessage: 'Reactions failed to load',
		description: 'A message shown when an error occurs when rendering reactions',
	},
	viewErrorTooltip: {
		id: 'reactions.view.error.tooltip',
		defaultMessage: 'Refresh to try again',
		description: 'A message telling the user to refresh the page',
	},
	addMutationError: {
		id: 'reactions.mutation.add.error',
		defaultMessage: 'Couldn’t add reaction',
		description: 'Message informing the user that adding a reaction failed',
	},
	deleteMutationError: {
		id: 'reactions.mutation.delete.error',
		defaultMessage: 'Couldn’t delete reaction',
		description: 'Message informing the user that deleting a reaction failed',
	},
	mutationErrorAction: {
		id: 'reactions.mutation.error.action',
		defaultMessage: 'Try again',
		description: 'Clickable link for the user to try the failed action again',
	},
	spotlightHeadline: {
		id: 'reactions.spotlight.headline',
		defaultMessage: 'Share your reaction',
		description: 'Headline for the reactions spotlight onboarding',
	},
	spotlightBody: {
		id: 'reactions.spotlight.body',
		defaultMessage: 'Leave a quick reaction to let your teammates know what you think!',
		description: 'Body text for the reactions spotlight onboarding',
	},
	spotlightDone: {
		id: 'reactions.spotlight.done',
		defaultMessage: 'OK',
		description: 'Done button text for the reactions spotlight onboarding',
	},
});
